import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash/fp';
import {
  forceTrailingSlash,
  shouldAddTrailingSlash,
} from '../../../utils/urlUtils';

// Since DOM elements <a> cannot receive activeClassName,
// destructure the prop here and pass it only to GatsbyLink
const Link = ({ activeClassName, children, className, target, to }) => {
  /* We need to refactor this logic to be cleaner.
     We shouldn't have to have null checks
     2x for both 'to' and 'link' constants.
  */

  // Handle error when to value is null (logic needs refactor)
  if (!to || !to.link) {
    return null;
  }

  if (typeof to === 'string') {
    return (
      <a
        href={shouldAddTrailingSlash(to) ? forceTrailingSlash(to) : to}
        className={className}
        target={target}
      >
        {children}
      </a>
    );
  }

  const { link: linkObj } = to;
  const [link] = linkObj;

  // Handle error when link value is null (logic needs refactor)
  if (!link) {
    return null;
  }

  // We'll use Gatsby Link for internal links after we migrate off D7
  if (!link.externalLink && link.slug) {
    return (
      <a
        href={forceTrailingSlash(link.slug.current)}
        activeclassname={activeClassName}
        className={className}
      >
        {children}
      </a>
    );
  }
  if (!link.externalLink && link.fileLink) {
    return (
      <a href={_.getOr('', 'fileLink.asset.url', link)} className={className}>
        {children}
      </a>
    );
  }
  if (!link.externalLink && link.phoneNumber) {
    const phoneNumber = link.phoneNumber.replace(/[\s().-]/g, '');
    return (
      <a href={`tel:${phoneNumber}`} className={className}>
        {children}
      </a>
    );
  }
  return (
    <a href={link.externalLink} className={className}>
      {children}
    </a>
  );
};

Link.propTypes = {
  activeClassName: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.string,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  target: PropTypes.string,
};

Link.defaultProps = {
  activeClassName: '',
  children: '',
  className: null,
  to: null,
  target: null,
};

export default Link;
